import AbstractAccountRow from "./AbstractAccountRow.js";
import AccountFormulaNode from "../../../keyFigure/formula/AccountFormulaNode.js";
import AccountNumberListSpecification from "../../../accountSpecification/AccountNumberListSpecification.js";

/**
 * Single account report row.
 *
 * @param {account} spec.account - Account of the row
 */
class AccountRow extends AbstractAccountRow {
	constructor({ account } = {}) {
		super(...arguments);
		this._account = account;
	}

	getAccount() {
		return this._account;
	}

	getAccountNumber() {
		return this._account.getNumber();
	}

	getFullTitleString() {
		return `${this.getAccountNumber()} - ${super.getFullTitleString()}`;
	}

	getTitle() {
		return this._createTitleWithAccountOperationShortName(
			this._account.getName(),
		);
	}

	isAccountRow() {
		return true;
	}

	isForAccountNumber(accountNumber) {
		return this.getAccountNumber() === accountNumber;
	}

	hasAccountPartOf(accountGroupId) {
		return this.getReport()
			.getChartOfAccounts()
			.hasAccountInGroup({ account: this.getAccount(), accountGroupId });
	}

	accept(visitor) {
		return visitor.visitAccountRow(this);
	}

	compareTo(anotherRow) {
		if (anotherRow.constructor === this.constructor) {
			return this.getAccount().compareTo(anotherRow.getAccount());
		}
		return super.compareTo(anotherRow);
	}

	asSpecification() {
		return new AccountNumberListSpecification({
			accountNumbers: [this.getAccountNumber()],
		});
	}

	_asBaseFormulaNode() {
		return new AccountFormulaNode({
			accountSpecification: this.asSpecification(),
		});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.expression = this.asFormulaNode();
		properties.accountNumber = this.getAccountNumber();

		return properties;
	}

	static getType() {
		return "AccountRow";
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.account = context.findAccountByNumber(data.accountNumber);
	}
}

export default AccountRow;
